import React, { useState, useEffect, useRef } from 'react';
import {getRecords} from '../../pages/api';

function Swiper () {
    const [list, setList] = useState([]);
    const refSwiper = useRef(null);
    const fetchRecords = async () => {
        const {result} = await new getRecords({}).fetch();
        if (result.code === 200 && result.result && result.result.list) {
            setList(result.result.list);
        }
    }

    useEffect(() => {
        fetchRecords();
        const swiperNode = refSwiper.current;
        // const isIE9Tag = isIE9();
        let offsetWidth = 0;
        let interval;
        // if(isIE9Tag) {
            let left = 0;
            interval = setInterval(() => {
                if (offsetWidth <= 0) {
                    offsetWidth = swiperNode.offsetWidth;
                }
                
                swiperNode.style.marginLeft = `${left}px`;
                left -= 1;
                if (left <= -offsetWidth) {
                    left = 0;
                }
            }, 20)
        // }
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        }
    }, [])

    return (
        <div className="m-swiper-info f-clear">
            <div className="m-swiper-info-hd">抽奖直播</div>
            <div className="m-swiper-info-wrapper">
                <div className="w-swiper-info-move" style={{}} ref={refSwiper}>
                    {
                        list.map((item, index) => {
                            return <div className="w-swiper-info-item" key={index}>{item.uid}获得了{item.prizeName}</div>
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default Swiper;